/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_chat_select_public = /** @type {(inputs: {}) => string} */ () => {
	return `Público`
};

const en_chat_select_public = /** @type {(inputs: {}) => string} */ () => {
	return `Public`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const chat_select_public = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.chat_select_public(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("chat_select_public", locale)
	if (locale === "es") return es_chat_select_public(inputs)
	return en_chat_select_public(inputs)
};
export { chat_select_public as "chat.select_public" }